import React, { Component } from "react";
import { Auth, API, graphqlOperation } from "aws-amplify";
import { createCustomer } from "../graphql/mutations";
import { listCustomers, listVehicles } from "../graphql/queries";
import { Jumbotron, Col, Row, Container, Button } from "reactstrap";
import { Link } from "react-router-dom";
// import Context from '../data/context';
class DashboardCustomer extends Component {

  render() {
    return (
      <div>
        <main ref="main" className="portalPage">
          <section className="section-profile-cover section-shaped bg-light">
            <Container className="">
              <Row className="justify-content-center">
                <Col xs="12">
                  <Jumbotron className="shadow-lg">
                    <h1 className="display-3">Customer DashBoard</h1>

                    <hr />

                    <p className="lead">
                      <Row>
                        <Col>
                          {" "}
                          <Button
                            className="text-lg btn-block"
                            color="info"
                            to="/vForm-page"
                            tag={Link}
                          >
                            Vehicle Information Form
                          </Button>
                        </Col>
                        <Col>
                          <Button
                            className="btn-block"
                            color="info"
                            to="/vType-page"
                            tag={Link}
                          >
                            Vehicle Type Form
                          </Button>
                        </Col>{" "}
                      </Row>
                    </p>
                  </Jumbotron>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}

export default DashboardCustomer;



// WEBPACK FOOTER //
// ./src/pages/DashboardCustomer.js